export default __webpack_public_path__ + "static/media/social-twitter.536733a8.svg";